import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

class RowThreeBlock extends Component {
  constructor(props) {
    super(props)
    this.state = { ...props }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  returnRow(row) {
    switch (row.type) {
      case 'img':
        return (
          <div className="aspectRatioPlaceholder">
            <div className="aspectRatioPlaceholder-fill"></div>
            <div className="imageWrapper">
              <img src={row.imageURL} />
            </div>
          </div>
        )
      case 'h2':
        return (
          <div className={row.style}>
            <h2>{row.label}</h2>
          </div>
        )
      case 'h2-xl':
        return (
          <div className={row.style}>
            <h2 className={row.firstClass}>{row.firstLabel}</h2>
            <h2>{row.secondLabel}</h2>
          </div>
        )
    }
  }
  render() {
    let data = this.state && this.state.data,
        that = this

    let firstRow, secondRow, thirdRow, items, title
    if (data) {
      title = data.title ? <h3 style={{marginBottom: '50px'}}>{data.title}</h3> : ''
      data = [data.content[0], data.content[1], data.content[2]]
    }

    return (
      <section className="main-grid center">
        <ul className="grid group">
          {title}

          {
            data && data.map((item, i) => {
              let firstRow = that.returnRow(item.firstRow)
              return (
                <li className={item.style} key={i}>
                  <figure className="grid-small-block">
                    <a href={item.linkURL} target="_blank">
                      {firstRow}
                      <figcaption className="grid-meta">
                        <h5 className="grid-item-title">{item.title}</h5>
                      </figcaption>
                    </a>
                  </figure>
                </li>
              )
            })
          }

        </ul>
      </section>
    )
  }
}

RowThreeBlock.contextTypes = {
}
RowThreeBlock.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}
export default connect(mapStateToProps)(RowThreeBlock)



// WEBPACK FOOTER //
// ./src/components/Utils/RowThreeBlock.js